// extracted by mini-css-extract-plugin
export default {"main":"AppLayout_main__pbvag"};